import ApiService from '../../../../shared/services/ApiService';

export default {

    getCompany () {
        return ApiService.get('company');
    },
    updateCompanyName(data) {
        debugger;
        return ApiService.post('company-change-name', data);
    },

    getInitData(){
        return ApiService.get('init');
    },

    getCompanyAdmins() {
        return ApiService.get('transfer-ownership');
    },

    transferOwnership(id) {
        return ApiService.post('/transfer-ownership', id);
    },

    companyDeactivate(params) {
        return ApiService.post('company-deactivate', params)
    },

    updateCompanySettings(data) {
        return ApiService.post('company-settings', data);
    },

    disconnectQuickBookAccount(){
        return ApiService.get('quickbooks-disconnect-modal');
    },

    getQuickBookImportData(){
        return ApiService.get('quickbook-import');
    },

    quickBookMatchUsers(data){
        return ApiService.post('match-quickbooks-users', data)
    },

    activateShareInvite(){
        return ApiService.get('activate-share-invite')
    },

    deactivateShareInvite(){
        return ApiService.get('deactivate-share-invite')
    },
    // Xero Routes
    getXeroEmployees(){
        return ApiService.get('xero-employees')
    },
    xeroMargeUsersWithAtto(data){
        return ApiService.post('marge-xero-users', data)
    },
    getXeroPayItems(){
        return ApiService.get('xero-pay-items')
    },
    postXeroPayItems(data){
        return ApiService.post('xero-pay-items', data)
    },
    disconnectXero(){
        return ApiService.get('xero-disconnect')
    },
    getXeroTimesheetsPeriod(){
        return ApiService.get('xero-payroll-calendars')
    },
    postTimeseetsToXero(data){
        return ApiService.post('xero-timesheet', data)
    },
    updatePayCalendars(){
        return ApiService.get('xero-update-employee-payroll-calendar')
    },


}